import { Component, ViewChild } from '@angular/core';
import { Events, Searchbar, ViewController } from 'ionic-angular';

import { Api }   from '../../providers/api/api';
import { User }  from '../../providers/user/user';
import { IPTV }  from '../../providers/iptv/iptv';
import { Utils } from '../../providers/utils/utils';
import { Fav }   from '../../providers/fav/fav';

/*
*
*  Search Page
*
*/
@Component({
  selector: 'search',
  templateUrl: 'search.html'
})
export class Search {

    @ViewChild('searchBar') searchBar: Searchbar;

    public isLoading : boolean = false;
    public channels : any = [];
    public items: any = [];
    public empty:boolean = true;
    public emptyChannels:boolean = false;
    public liveSearch : any = {};
    public q:string='';

    constructor( 
        private view: ViewController,
        public utils: Utils,
        public events: Events, 
        public IPTV: IPTV,
        private api : Api,
        public user: User,
        public fav: Fav
    ) {

        this.events.subscribe('live:loading', () => { 
            this.setLoading();
        });

        this.events.subscribe('live:success', (text = '') => { 
            this.setSuccess(text);
        });

        this.events.subscribe('live:error', (text = '') => { 
            this.setError(text);
        });

    }

    closeModal() {
        this.view.dismiss();
    }

    ionViewDidEnter() {
        setTimeout(() => {
          this.searchBar.setFocus();
        }, 100);
    }

    search() {

        if (!this.q) {
            this.items = [];
            return false;
        }
        
        this.isLoading = true;

        this.searchAPI().then((data: any = []) => {
            let channels = data;

            this.fav.getFavorites().then((data2 : any = []) => {

                for(let channel of channels) {
                    channel.fav = false;
                    for(let fav of data2) {
                        if (fav.id == channel.id) {
                            channel.fav = true;
                        } 
                    }
                }

                for (let chan of channels) {
                    for (let box of this.IPTV.boxs) {
                        if (parseInt(box.id_box) == parseInt(chan.id_box)) {
                            chan.box_name = box.name;
                        }
                    }
                }

                this.items = channels;
                this.isLoading = false;

            });

        });

    }

    searchAPI() {
        return new Promise((resolve, reject) => {
            this.api.put('iptv/search/'+this.q, {sources:this.IPTV.boxs}).subscribe((response:any)=>{
                resolve(response.result.result);
            },(err) => {
                reject(this.api.reject(err));
            });
       });
    }

    remote (item) {

        if (this.liveSearch.active) return false;

        if (item.box_name == this.IPTV.box.name) {
            this.remoteOrCast(item);
        } else {

            let boxID = 0;

            for (let box of this.IPTV.boxs) {
                if (box.name == item.box_name) boxID = box.id;
            }

            
            this.changeBox(boxID).then(() => {
                this.remoteOrCast(item);
            }, (err) => {
                if (err) this.utils.error(err);
            });    
        }
    }

    remoteOrCast(item)
    {
        if (this.IPTV.box.manufacturer == 'CHROMECAST' ) {
            this.IPTV.cast('',item.parameter, item.name, item.type_name);
        } else {
            this.IPTV.remote(item.parameter, {label:item.name});
        }

    }

    changeBox(boxID) {

        return new Promise((resolve, reject) => {

            this.events.publish('live:loading');
    
            this.IPTV.setSource(boxID).then(() => {
                this.events.publish('live:success');
                this.events.publish('app:refresh');
                resolve();
            }, (err) => {
                this.events.publish('live:error');
                reject();
            });

        });
    }

    setLoading() {
        this.setSearchLive('','grey','',true);
    }

    setSuccess(text = '') {
        this.setSearchLive(text, 'success', 'checkmark-circle');
    }

    setError (text = '') {
        this.setSearchLive(text, 'danger', 'close-circle');
    }

    setSearchLive(text = '', color = '', icon = '', noTimer = false) {

         if (this.liveSearch.timer) clearTimeout(this.liveSearch.timer);

        this.liveSearch.active = true;
        this.liveSearch.name  = ( text ? this.utils.truncate(text,15,'..') : ' ');
        this.liveSearch.color = color;
        this.liveSearch.icon  = icon;

        if (!noTimer) {
            this.liveSearch.timer = setTimeout( () => {
             this.liveSearch = {};
            }, 1000);
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts